import AddPrinterModal from '@/features/settings/components/AddPrinterModal'
import PrintManagement from '@/features/settings/components/PrintManagement'
import { AddPrinterData, useAddPrinterActions } from '@/features/settings/contexts/AddPrinter'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { useScreenLayout } from '@/hooks/screen'
import { removePrinter } from '@/redux/reducers/printers'
import { printersSelectors } from '@/redux/reducers/printers/selectors'
import { useRouter } from 'expo-router'
import { FC, useState } from 'react'

const PrinterManagementPage: FC = () => {
    const layout = useScreenLayout()
    const router = useRouter()

    const dispatch = useAppDispatch()
    const printers = useAppSelector(printersSelectors.printers)

    const { setData, unsetData } = useAddPrinterActions()

    const [showAddPrinterModal, setShowAddPrinterModal] = useState(false)

    const handleAddPrinterContinue = async (data: AddPrinterData) => {
        setData(data)
        setShowAddPrinterModal(false)
        router.push('/settings/printers/new')
    }

    const handleAddCancel = () => {
        unsetData()
        setShowAddPrinterModal(false)
    }

    const handleAdd = () => setShowAddPrinterModal(true)

    const handleEdit = (printerId: string) => {
        router.push({
            pathname: '/settings/printers/edit/[id]',
            params: { id: printerId },
        })
    }

    const handleDelete = (printerId: string) => {
        dispatch(removePrinter(printerId))
    }

    if (!printers) {
        return null
    }
    return (
        <>
            <PrintManagement
                layout={layout}
                printers={printers}
                onAddPrinter={handleAdd}
                onEditPrinter={handleEdit}
                onDeletePrinter={handleDelete}
            />
            {showAddPrinterModal && (
                <AddPrinterModal onCancel={handleAddCancel} onContinue={handleAddPrinterContinue} />
            )}
        </>
    )
}

export default PrinterManagementPage
